import type { ExcalidrawElement } from "../element/types";
import type { ExcalidrawElementWithCanvas } from "../renderer/renderElement";

/**
 * Canvas render cache, filled by `renderElement` and invalidated by
 * `ShapeCache`. Lives outside the renderer so invalidation does not pull in
 * its module-load DOM calls (the type import above is erased at build).
 */
export const elementWithCanvasCache = new WeakMap<
  ExcalidrawElement,
  ExcalidrawElementWithCanvas
>();
